"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_TALK = exports.UPDATE_TALK = void 0;
const react_1 = __importStar(require("react"));
const route_1 = require("../route");
const react_bootstrap_1 = require("react-bootstrap");
const copilotApi_1 = require("@/schemaComponents/modules/copilotApi");
const fromFetchSSEStream_1 = require("copilot-js/dist/helpers/fromFetchSSEStream");
const schemaComponents_1 = require("@/schemaComponents");
const classes = __importStar(require("./style.module.scss"));
const prompt_text_1 = require("./prompt.text");
const standard_1 = require("react-hook-schema/standard");
exports.UPDATE_TALK = route_1.TALK.sub("/edit", Talk);
exports.ADD_TALK = route_1.TALKS.sub("/new", Talk);
function Talk({ talkId, projectId }) {
    const loading = false;
    const [systemPrompt, setSystemPrompt] = (0, react_1.useState)(prompt_text_1.defaultSystemPrompt);
    const [userPrompt, setUserPrompt] = (0, react_1.useState)(prompt_text_1.defaultUserPromptScratch);
    const [text, setText] = (0, react_1.useState)(prompt_text_1.defaultInstructionScratch);
    const [activeKey, setActiveKey] = (0, react_1.useState)(null);
    console.log("text", text);
    const setPreset = (0, react_1.useCallback)((preset) => {
        console.log("preset", preset);
        setActiveKey((activeKey) => {
            const activeKeys = new Set(activeKey ? (Array.isArray(activeKey) ? activeKey : [activeKey]) : []);
            if (preset) {
                activeKeys.add("1");
            }
            else {
                activeKeys.delete("1");
            }
            return Array.from(activeKeys);
        });
        if (preset === "scratch") {
            setText(`麦わらの一味が地底を探検するというテーマで新しいシナリオを考えて`);
            setUserPrompt(prompt_text_1.defaultUserPromptScratch);
        }
        else if (preset === "brushUp") {
            setText(prompt_text_1.defaultInstructionBrushUp);
            setUserPrompt(prompt_text_1.defaultUserPromptBrushUp);
        }
    }, [setText]);
    const [evaluation, setEvaluation] = (0, react_1.useState)();
    const controllerRef = react_1.default.useRef();
    const errorModal = (0, standard_1.useErrorModal)();
    const startCompletion = (0, react_1.useCallback)(() => {
        var _a;
        try {
            (_a = controllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
            const controller = new AbortController();
            controllerRef.current = controller;
            setEvaluation("");
            const callback = (fragment) => {
                setEvaluation((prev) => {
                    return (prev || "") + fragment;
                });
            };
            const filter = (0, copilotApi_1.createFilter)(callback, false);
            const responsePromise = (() => __awaiter(this, void 0, void 0, function* () {
                const response = yield (0, copilotApi_1.prepareTranslation)({
                    langId: "en",
                    text: text || "",
                    projectId,
                });
                const json = response.data;
                const { context: scripts } = json;
                const context = scripts.map((script) => script.text).join("\n");
                const _systemPrompt = (systemPrompt || "").replaceAll("{context}", context);
                const _userPrompt = (userPrompt || "").replaceAll("{text}", text || "");
                const messages = [
                    {
                        role: "system",
                        content: _systemPrompt,
                    },
                    {
                        role: "user",
                        content: _userPrompt || "",
                    },
                ];
                console.log("messages", messages);
                return (0, copilotApi_1.chatCompletion)({
                    // model: "gpt-4-turbo-preview",
                    model: "gpt-35-turbo",
                    controller,
                    messages,
                });
            }))();
            (0, fromFetchSSEStream_1.fromFetchSSEStream)({
                callback: (data) => {
                    if (data.choices.length === 0)
                        return;
                    filter(data.choices[0].delta.content || "");
                },
                controller,
                responsePromise,
            });
        }
        catch (e) {
            errorModal({
                error: e,
                internalMessage: "自動補完の生成に失敗しました",
                userMessage: "AI による自動補完の生成に失敗しました。多くの場合、しばらくお待ちいただくことで回復します。もし問題が回復しない場合、お問合せください。",
            });
        }
    }, [systemPrompt, userPrompt, text]);
    console.log("activeKey", activeKey);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: "hero" },
            react_1.default.createElement("div", { className: "hero-body" },
                react_1.default.createElement(react_bootstrap_1.Stack, { direction: "horizontal", gap: 3 },
                    react_1.default.createElement("h1", { className: "title" }, "\u30B7\u30CA\u30EA\u30AA\u4F5C\u6210(Experimental)")))),
        react_1.default.createElement("section", null, loading ? (react_1.default.createElement("div", { className: "card" },
            react_1.default.createElement("div", { style: { padding: "20px" } },
                react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", role: "status" },
                    react_1.default.createElement("span", { className: "visually-hidden" }, "Loading..."))))) : (react_1.default.createElement("div", { className: "card" },
            react_1.default.createElement(react_bootstrap_1.Accordion
            // defaultActiveKey={[]}
            , { 
                // defaultActiveKey={[]}
                activeKey: activeKey, onSelect: setActiveKey, flush: true },
                react_1.default.createElement("h3", { style: {
                        margin: "10px 20px",
                        fontWeight: "bold",
                    } },
                    react_1.default.createElement(CustomToggle, { eventKey: "0" }, "\u30B7\u30B9\u30C6\u30E0\u30D7\u30ED\u30F3\u30D7\u30C8")),
                react_1.default.createElement(react_bootstrap_1.Accordion.Collapse, { eventKey: "0" },
                    react_1.default.createElement("div", { style: {
                            margin: "0px 20px",
                            display: "flex",
                        } },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, defaultValue: systemPrompt, onChange: (e) => {
                                setSystemPrompt(e.target.value);
                            } }))),
                react_1.default.createElement("h3", { style: {
                        margin: "10px 20px",
                        fontWeight: "bold",
                    } },
                    react_1.default.createElement(CustomToggle, { eventKey: "1" },
                        react_1.default.createElement("span", { style: { flex: "none" } },
                            "\u30E6\u30FC\u30B6\u30D7\u30ED\u30F3\u30D7\u30C8",
                            react_1.default.createElement("span", { style: {
                                    fontWeight: "normal",
                                    flex: "none",
                                    marginLeft: "20px",
                                }, className: classes.forceInline },
                                react_1.default.createElement(schemaComponents_1.SchemaInput, { data: "none", schema: {
                                        schemaType: "selector",
                                        options: [
                                            {
                                                value: "scratch",
                                                title: "新規作成",
                                                tooltip: "指示を与えると、過去のデータに基づいて新しくシナリオを作成します",
                                            },
                                            {
                                                value: "brushUp",
                                                title: "ブラッシュアップ",
                                                tooltip: "シナリオを入力すると、過去のデータに基づいてシナリオを改善します",
                                            },
                                        ],
                                    }, onValueChange: setPreset }))))),
                react_1.default.createElement(react_bootstrap_1.Accordion.Collapse, { eventKey: "1" },
                    react_1.default.createElement("div", { style: {
                            margin: "0px 20px",
                            display: "flex",
                        } },
                        react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, value: userPrompt, onChange: (e) => {
                                setUserPrompt(e.target.value);
                            } })))),
            react_1.default.createElement("h3", { style: {
                    margin: "10px 20px",
                    fontWeight: "bold",
                } }, "\u6307\u793A"),
            react_1.default.createElement("div", { style: {
                    margin: "0px 20px",
                    display: "flex",
                } },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: "textarea", rows: 3, value: text, onChange: (e) => {
                        console.log("before setText", e.target.value);
                        setText(e.target.value);
                    } })),
            react_1.default.createElement(react_bootstrap_1.Button, { style: {
                    margin: "20px",
                    width: "80px",
                }, onClick: startCompletion }, "\u958B\u59CB"),
            react_1.default.createElement("h3", { style: {
                    margin: "10px 20px",
                    fontWeight: "bold",
                } }, "\u56DE\u7B54"),
            react_1.default.createElement("div", { style: {
                    maxWidth: "640px",
                    whiteSpace: "pre-wrap",
                    border: "1px solid #ddd",
                    padding: "10px",
                    borderRadius: "5px",
                    margin: "0px 20px",
                    minHeight: "80px",
                } }, evaluation))))));
}
exports.default = Talk;
function CustomToggle({ children, eventKey, }) {
    const { activeEventKey } = (0, react_1.useContext)(react_bootstrap_1.AccordionContext);
    const decoratedOnClick = (0, react_bootstrap_1.useAccordionButton)(eventKey);
    const isActive = activeEventKey === eventKey;
    return (react_1.default.createElement("div", { style: {
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
        }, onClick: decoratedOnClick },
        children,
        react_1.default.createElement("i", { className: isActive ? "mdi mdi-chevron-up" : "mdi mdi-chevron-down" })));
}
